import React from "react";
import { Chip } from "../../helpers/general";
import { controlStyle } from "../../helpers/constants";
import { general } from "../../locales/general";
import { cardStyle } from "../../pages/Places/PlacesTable";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";
import PointsHistoryTable from "./tables/PointTable";

const POINT_TYPES = [
  { label: "Tous", value: "" },
  { label: "Réservation", value: "BOOKING" },
  { label: "Course", value: "RIDE" },
];

interface Props {
  data: any;
  isLoading: boolean;
  filters: any;
  setFilters: (filters: any) => void;
  onPageChange: (page: number) => void;
  user: User;
}

export const UserPointsHistoryTab: React.FC<Props> = ({
  data,
  isLoading,
  filters,
  setFilters,
  onPageChange,
  user,
}) => {
  const total = data?.meta?.totalItems ?? 0;
  const totalPages = data?.meta?.totalPages ?? 0;

  return (
    <div>
      {/* Title + points balance */}
      <div className="d-flex align-items-center gap-2 mb-3 ms-4">
        <h5 className="fs-5 fw-bold mb-0">Historique des points</h5>
        <Chip tone="warning">Points : {user.points}</Chip>
      </div>

      {/* Filters */}
      <div
        style={{ ...cardStyle, padding: "14px 16px" }}
        className="d-flex flex-wrap align-items-end gap-3 mb-3"
      >
        <div className="d-flex flex-column gap-1">
          <label
            htmlFor="points-type"
            className="text-muted mb-0"
            style={{ fontSize: 11 }}
          >
            Type
          </label>
          <select
            id="points-type"
            className="form-select px-3"
            style={{ ...controlStyle, width: "auto", minWidth: 160 }}
            value={filters.type || ""}
            onChange={(e) =>
              setFilters({ ...filters, type: e.target.value, page: 1 })
            }
          >
            {POINT_TYPES.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Table */}
      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={isLoading && total === 0}
          render={() =>
            total > 0 ? (
              <PointsHistoryTable items={data.items} />
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={filters.page}
          onPageChange={onPageChange}
          totalCount={totalPages}
          pageSize={filters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
